import { Button, Flex, Form, Select, Tooltip, Typography } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getServiceProviderSubscriptionsAction } from "../../../../../../redux/services/service-provider-subscriptions/serviceProviderSubscriptionsServices";
import { IconOffer, ProMembershipIcon } from "../../../../../../assets/svg";
import { colors } from "../../../../../../constants/colors";
import { RocketOutlined, CheckOutlined } from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import "./Subscriptions.scss";
import Actions from "../../../../../../redux/actions";
import { useNavigate } from "react-router-dom";
import {
  baseRouteMaker,
  routes,
} from "../../../../../../constants/routeConsts";
import useLocalStorage from "../../../../../../hooks/useLocalStorage";
import { appConfig } from "../../../../../../constants/config/appConfig";
import { getUserProfileAction } from "../../../../../../redux/services/auth/authServices";
import Spinner from "../../../../../common/spinner/Spinner";
import DowngradeConfirmationDialog from "./DowngradeConfirmationDialog";

const Subscriptions = () => {
  /* i18n dependencies */
  const { t } = useTranslation();
  /* i18n dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigate dependencies */
  const navigate = useNavigate();
  /* navigate dependencies */

  /* local storage dependencies */
  const { userSession, setUserSession } = useLocalStorage(
    appConfig.SESSION_USER_INFO
  );
  /* local storage dependencies */

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  /* loading dependencies */

  /* form dependencies */
  const [form] = Form.useForm();
  const [selectedPlan, setSelectedPlan] = useState({});
  const [selectedSubscriptionPlanCode, setSelectedSubscriptionPlanCode] =
    useState("");
  const [selectedSubscriptionPlanId, setSelectedSubscriptionPlanId] =
    useState("");
  const [downgradeConfirmationDialog, setDowngradeConfirmationDialog] = useState(false);
  /* form dependencies */

  /* table dependencies */
  const { serviceProviderSubscriptions } = useSelector(
    (state) => state.serviceProviderSubscriptions
  );
  const { loginDetails } = useSelector((state) => state.auth);
  /* table dependencies */

  /* function definition to get table data */
  const handleGetTableData = () => {
    dispatch(
      Actions.createAction(Actions.SELECTED_SUBSCRIPTION_PLAN_DETAILS, {})
    );
    dispatch(getServiceProviderSubscriptionsAction(setLoading));
  };
  /* function definition to get table data */

  useEffect(() => {
    setLoading(true);
    userSession &&
      Object.keys(userSession).length !== 0 &&
      userSession !== null &&
      userSession !== undefined &&
      dispatch(getUserProfileAction(setUserSession));

    setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    handleGetTableData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const subscriptionCodes = {
    "FREE": {
      icon: <IconOffer fillColor={colors.deepSafron} />,
      color: colors.deepSafron,
      lightColor: colors.lightBeige,
    },
    "PREMIUM": {
      icon: (
        <RocketOutlined style={{ color: colors.royalPurple, fontSize: 20 }} />
      ),
      color: colors.royalPurple,
      lightColor: colors.lavenderBlue,
    },
    "ELITE-PREMIUM": {
      icon: <ProMembershipIcon fillColor={colors.turquoise} />,
      color: colors.turquoise,
      lightColor: colors.lightCyan,
    },
  };

  const onSubscriptionPlanChanged = (value, id) => {
    const selectedSubscriptionPlan = serviceProviderSubscriptions?.data?.reduce(
      (accumulator, subscriptionPlan) => {
        subscriptionPlan.pricing?.find((pricing) => {
          if (pricing._id === value) accumulator.foundObj = pricing;
        });

        return accumulator;
      },
      {}
    );

    const tempSelectedPlanValue = { ...selectedPlan };
    tempSelectedPlanValue[id] = selectedSubscriptionPlan?.foundObj;
    setSelectedPlan((prevValue) => ({
      ...prevValue,
      ...tempSelectedPlanValue,
    }));
    setSelectedSubscriptionPlanId(id);
    
  };

  const applySubscriptionPlan = async (id, plan) => {
    try {
      const subscriptionPlanFieldName = `plan_${id}`;
      await form.validateFields([subscriptionPlanFieldName]);

      const dataToBeSent = {
        type: "main",
        event_type: "SUBSCRIPTION",
        subscription_plan: plan?.code,
        subscription_plan_id: id,
        selectedPlan: selectedPlan[id],
        number_of_logins:plan?.number_of_logins
      };

      dispatch(
        Actions.createAction(Actions.SELECTED_SUBSCRIPTION_PLAN_DETAILS, {
          selectedSubscriptionPlanDetails: dataToBeSent,
        })
      );
      dispatch(Actions.createAction(Actions.CLEAR_COUPON));
      navigate(baseRouteMaker(routes.SUBSCRIPTION_PAYMENT));
    } catch (errorInfo) {}
  }

  /* on submit */
  const onSubmit = async (id, plan) => {
    // if(plan?.number_of_logins < loginDetails?.organization_id?.free_users_created) {
    //   setDowngradeConfirmationDialog(true);
    //   await applySubscriptionPlan(id, plan)
    // }
    // else {
    //   await applySubscriptionPlan(id, plan)
    //   navigate(baseRouteMaker(routes.SUBSCRIPTION_PAYMENT));
    // }
    await applySubscriptionPlan(id, plan)
  };
  /* on submit */

  /* filtered Subscription array */
  const filteredSubscriptionArr = [];
  /* filtered Subscription array */

  filteredSubscriptionArr.push("FREE");
  if (loginDetails?.organization_id?.current_plan_id?.code !== "FREE") {
    filteredSubscriptionArr.push(
      loginDetails?.organization_id?.current_plan_id?.code
    );
  }


  const downgradeConfirmationDialogProps = useMemo(()=>({
    open:downgradeConfirmationDialog,
    onClose:() => {
      setDowngradeConfirmationDialog(false)
    }
  }),[downgradeConfirmationDialog])


  const CannotDowngradePlanLayout = React.memo(({ children, isElitePremiumPlan }) => {
    return (
      <>
        <Tooltip
          placement="topLeft"
          title={isElitePremiumPlan ? t("CommonUtils.cannotDowngradeToPremiumPlan") : ""}
          color={colors.limeGreen}
          destroyTooltipOnHide
          autoAdjustOverflow
        >
          {children}
        </Tooltip>
      </>
    );
  });

  return (
    <Flex gap="2rem" justify="center">
      {
        loading ?
        <Spinner/>
        :
        serviceProviderSubscriptions?.data
        ?.filter((element) => !filteredSubscriptionArr.includes(element.code))
        .map((plan) => {
          return (
            <CannotDowngradePlanLayout isElitePremiumPlan={loginDetails?.organization_id?.current_plan_id?.code === "ELITE-PREMIUM"}>
            <div
              className="cardContainer"
              style={{
                width: 400,
                height: 500,
                boxShadow: "1px 4px 8px rgba(0,0,0,0.1)",
                background: "#F5F5F5",
                border: `1px solid ${subscriptionCodes[plan?.code]?.color}`,
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "column",
                padding: 20,
                borderRadius: 20,
              }}
            >
              <div style={{
                display:'grid',
                gap:'1rem',
                gridTemplateRows:'3rem 11rem 1rem 5rem'
              }}>
                <Flex gap="1rem" align="center">
                  <div
                    style={{
                      borderRadius: "50%",
                      border: `4px solid ${
                        subscriptionCodes[plan?.code]?.color
                      }`,
                      width: 40,
                      height: 40,
                      textAlign: "center",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {subscriptionCodes[plan?.code]?.icon}
                  </div>
                  <Typography.Title level={2}>{plan?.name}</Typography.Title>
                </Flex>

                <div>
                  {plan?.features &&
                    plan?.features?.map((feature, index) => (
                      <Flex gap="1rem">
                        <CheckOutlined
                          style={{
                            color: subscriptionCodes[plan?.code]?.color,
                            background:
                              subscriptionCodes[plan?.code]?.lightColor,
                            borderRadius: "50%",
                            width: 25,
                            height: 25,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        />
                        <Typography.Paragraph key={index}>
                          {feature}
                        </Typography.Paragraph>
                      </Flex>
                    ))}
                </div>
                <Flex align="center" justify="center">
                  <Typography.Title level={3}>
                  {t("CommonUtils.noOfUsers")} : {plan?.number_of_logins}
                  </Typography.Title>
                </Flex>

                {plan?.code !== "FREE" && (
                  <Form style={{ marginTop: 20 }} form={form} layout="vertical">
                    <Form.Item
                      name={`plan_${plan._id}`}
                      rules={[
                        {
                          required: true,
                          message: t(
                            "Modules.Subscriptions.pleaseSelectSubscriptionPlan"
                          ),
                        },
                      ]}
                    >
                      <Select
                        options={plan?.pricing?.map((element) => ({
                          value: element._id,
                          label: `${element.duration} month`,
                          price: `${element.price} ${element.currency}`,
                        }))}
                        placeholder={t(
                          "Modules.Subscriptions.selectSubscriptionPlan"
                        )}
                        allowClear
                        onChange={(value) => {
                          setSelectedSubscriptionPlanCode(plan?.code);
                          onSubscriptionPlanChanged(value, plan?._id);
                        }}
                        // disabled={loginDetails?.organization_id?.current_plan_id?.code === "ELITE-PREMIUM"}
                      />
                    </Form.Item>
                  </Form>
                )}
              </div>
              <Flex vertical align="center" justify="center" gap="1rem">
                {selectedPlan &&
                  selectedPlan !== null &&
                  selectedPlan !== undefined && (
                    <Flex gap="0.8rem">
                      <Typography.Title
                        level={2}
                        style={{
                          color: subscriptionCodes[plan?.code]?.color,
                          margin: 0,
                        }}
                      >
                        {selectedPlan[plan._id]
                          ? `${selectedPlan[plan._id]?.price} ${
                              selectedPlan[plan._id]?.currency
                            }`
                          : ""}
                      </Typography.Title>
                      {selectedPlan[plan._id]?.duration !== 1 && (
                        <Typography.Title
                          level={5}
                          style={{
                            color: subscriptionCodes[plan?.code]?.color,
                            margin: 0,
                            textDecoration: "line-through",
                          }}
                        >
                          {selectedPlan[plan._id]
                            ? `${
                                selectedPlan[plan._id]?.duration *
                                (plan.code === "Premium" ? 50 : 100)
                              } ${selectedPlan[plan._id]?.currency}`
                            : ""}
                        </Typography.Title>
                      )}
                    </Flex>
                  )}
                {plan?.code !== "FREE" && (
                  <Button
                    style={{
                      background: loginDetails?.organization_id?.current_plan_id?.code === "ELITE-PREMIUM" ? colors.lightRoyalPurple : subscriptionCodes[plan?.code]?.color,
                      color: colors.white,
                      width: "100%",
                    }}
                    onClick={() => onSubmit(plan._id, plan)}
                    disabled={loginDetails?.organization_id?.current_plan_id?.code === "ELITE-PREMIUM"}
                  >
                    {t("CommonUtils.purchaseNow")}
                  </Button>
                )}
              </Flex>
            </div>
            </CannotDowngradePlanLayout>
          );
        })
      }
      <DowngradeConfirmationDialog {...downgradeConfirmationDialogProps}/>
    </Flex>
  );
};

export default Subscriptions;
